module.exports = __webpack_public_path__ + "static/media/RedBullLogo.7273e4ee.png";